import { Component, OnInit } from '@angular/core';
import { FormBuilder, NgForm, FormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../../quote/quote.service';
import { PolicyService } from '../../../policy/policy.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExcessProtectService } from '../../../quote/excess-protect/excess.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-excess-protect-policy',
  templateUrl: './excess-protect-policy.component.html',
  styleUrls: ['./excess-protect-policy.component.css']
})
export class ExcessProtectPolicyComponent implements OnInit {
  id = this.route.snapshot.params.quote_id;
  selectedIndex = 0;
  isAdmin = false;
  isStaff = false;
  isBroker = false;
  isInsurer: boolean = false;
  hasImportantClaims: boolean = false;

  constructor(private policyService: PolicyService, private expService: ExcessProtectService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal,
    private quoteService: QuoteService, private sessionSt: LocalStorageService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }

    if (this.sessionSt.retrieve('is_broker')) {
      this.selectedIndex = 5;
    }

    if (this.sessionSt.retrieve('is_insurer')) {
      this.isInsurer = true;
    }

    this.getQuote();
  }
  // GET QUOTE DETAILS
  quoteDetails: any = {};
  fullQuote;
  policyID: string = '';
  hideMTA: boolean = false;
  is_policy_active: boolean = false;
  policy_status: string = '';
  isMTANotProcessed: boolean = false;
  getQuote() {
    this.expService.getQuoteDetails(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {
          if (response.result.quote_data.policy_status == 1) {
            this.is_policy_active = true;
          }
          else {
            this.is_policy_active = false;
          }

          this.policyID = response.result.quote_data.quote_versions[0].id;


          let res_quote = response.result.quote_data.quote_versions.filter(x => x.id == this.route.snapshot.params.quote_id);
          let quoteData = res_quote[0];

          let all_policies = response.result.quote_data.quote_versions.filter(x => x.is_policy == 1);
          if (all_policies && all_policies.length > 0) {
            let latest_policies = all_policies.filter(x => x.sequence_number > quoteData.sequence_number);
            if (latest_policies && latest_policies.length > 0) {
              this.hideMTA = true;
            }
          }

          //MTA but not processed to policy
          let mta_data = response.result.quote_data.quote_versions.filter(x => x.is_policy != 1 && x.type == 3);
          if (mta_data.length > 0) {
            this.isMTANotProcessed = true;
          }

          this.quoteDetails = quoteData;
          this.quoteDetails.id = quoteData.id;
          this.quoteDetails.insurance_status_id = quoteData.insurance_status_id;
          this.quoteDetails.company_id = quoteData.company_id;
          this.quoteDetails.company_name = quoteData.policy_holder.company_name;
          this.quoteDetails.is_send_email = quoteData.is_send_email;
          this.quoteDetails.type = quoteData.type;
          this.quoteDetails.broker_id = quoteData.broker_id;
          this.quoteDetails.notes = quoteData.notes;
          if (quoteData.financial_details) {
            this.quoteDetails.peliwica_fee = quoteData.financial_details.fees;
            this.quoteDetails.broker_commission = quoteData.financial_details.broker_commission;
            this.quoteDetails.broker_admin_fee = quoteData.financial_details.broker_admin_fee;
          } else {
            this.quoteDetails.peliwica_fee = 0;
            this.quoteDetails.broker_commission = 0;
            this.quoteDetails.broker_admin_fee = 0;
          }

          this.quoteDetails.email = quoteData.policy_holder?.email;
          this.quoteDetails.phone = quoteData.policy_holder?.phone;
          this.quoteDetails.is_email = quoteData.policy_holder?.is_email;
          this.quoteDetails.is_phone = quoteData.policy_holder?.is_phone;
          this.quoteDetails.sms = quoteData.policy_holder?.sms;
          this.quoteDetails.post = quoteData.policy_holder?.post;
          this.quoteDetails.affinity_partner = quoteData.affinity_partner;
          this.quoteDetails.transactional_date = quoteData.transactional_date;
          this.fullQuote = quoteData;
          this.quoteDetails.is_paid = quoteData.is_paid;
          this.quoteDetails.product_id = quoteData.product_id;
          this.quoteDetails.is_policy = quoteData.is_policy;


          // this.quoteDetails = response.result.quote_data.quote_versions[0];
          // this.quoteDetails.id = response.result.quote_data.quote_versions[0].id;
          // this.quoteDetails.insurance_status_id = response.result.quote_data.quote_versions[0].insurance_status_id;
          // this.quoteDetails.company_id = response.result.quote_data.quote_versions[0].company_id;
          // this.quoteDetails.company_name = response.result.quote_data.quote_versions[0].policy_holder.company_name;
          // this.quoteDetails.is_send_email = response.result.quote_data.quote_versions[0].is_send_email;
          // this.quoteDetails.type = response.result.quote_data.quote_versions[0].type;
          // this.quoteDetails.broker_id = response.result.quote_data.quote_versions[0].broker_id;
          // this.quoteDetails.notes = response.result.quote_data.quote_versions[0].notes;
          // if (response.result.quote_data.quote_versions[0].financial_details) {
          //   this.quoteDetails.peliwica_fee = response.result.quote_data.quote_versions[0].financial_details.fees;
          //   this.quoteDetails.broker_commission = response.result.quote_data.quote_versions[0].financial_details.broker_commission;
          //   this.quoteDetails.broker_admin_fee = response.result.quote_data.quote_versions[0].financial_details.broker_admin_fee;
          // } else {
          //   this.quoteDetails.peliwica_fee = 0;
          //   this.quoteDetails.broker_commission = 0;
          //   this.quoteDetails.broker_admin_fee = 0;
          // }

          // this.quoteDetails.email = response.result.quote_data.quote_versions[0].policy_holder?.email;
          // this.quoteDetails.phone = response.result.quote_data.quote_versions[0].policy_holder?.phone;
          // this.quoteDetails.is_email = response.result.quote_data.quote_versions[0].policy_holder?.is_email;
          // this.quoteDetails.is_phone = response.result.quote_data.quote_versions[0].policy_holder?.is_phone;
          // this.quoteDetails.sms = response.result.quote_data.quote_versions[0].policy_holder?.sms;
          // this.quoteDetails.post = response.result.quote_data.quote_versions[0].policy_holder?.post;
          // this.quoteDetails.affinity_partner = response.result.quote_data.quote_versions[0].affinity_partner;
          // this.quoteDetails.transactional_date = response.result.quote_data.quote_versions[0].transactional_date;
          // this.fullQuote = response.result.quote_data.quote_versions[0];
          // this.quoteDetails.is_paid = response.result.quote_data.quote_versions[0].is_paid;
          // this.quoteDetails.product_id = response.result.quote_data.quote_versions[0].product_id;
          // this.quoteDetails.is_policy = response.result.quote_data.quote_versions[0].is_policy;
          //this.getQuoteNotes();
        },
        (error) => {
          ;
        }
      );
  }
  displayEmailView: boolean = false;
  displayNewEmailView: boolean = false;
  newEmailView() {
    this.displayNewEmailView = true;
  }

  email_id: string = '';
  getEmailView(email_id) {
    this.email_id = email_id;
    this.displayEmailView = true;
  }
  backToEmailsList() {
    this.displayEmailView = false;
    this.displayNewEmailView = false;
  }
  /*
* Convert To MTA
*/
  policyActions(type) {
    // if(this.isMTANotProcessed){
    //    this.modalService.open(MTAModel, { centered: true });
    //   return;
    // }
    //this.router.navigateByUrl("/excess-protect/quote/" + this.id + '/' + type);
    this.router.navigateByUrl("/excess-protect/quote/" + this.quoteDetails.id + '/' + type);
  }
  onhasClaimsChange(event) {
    this.hasImportantClaims = event;
  }
  /*
  * Cancel Policy Popup
  */
  submitted: boolean = false;
  cancellation_date;
  cancellation_reason;
  refund_amount;
  errorMsg: string = '';
  cancelPolicy(cancelModal: any) {
    this.modalService.open(cancelModal, { centered: true });
  }

  onSubmitCancelPolicy() {
    this.submitted = true;
    let data = {
      'meta': {
        "effective_date": formatDate(this.cancellation_date, 'yyyy-MM-dd', 'en-US'),
        "reason": this.cancellation_reason,
        "return_premium": this.refund_amount,
      }
    };


    this.expService.getCancelPolicy(data, this.policyID)
      .subscribe(
        (res: any) => {
          if (res) {
            this.modalService.dismissAll();
            this.getQuote();
          }
        }, err => {
          if (err.error.errors && err.error.errors.length > 0) {
            this.errorMsg = err.error.errors[0].detail;
          }
        });

    // API - GET NOTES
    this.quoteService.getQuoteClaims(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {
          let impClaims = response.result;
          if (impClaims.length > 0) {
            this.hasImportantClaims = true;
          }
        });
  }
  /*
* Convet To MTA PopUp - List of Reasons
*/
  mtaMsg: string = '';
  quoteType = '';
  convert_to_mta(content, type, delete_mta = 0) {
    // if (type == 3 || type == 6) {
    this.policyService.mtaCheckExpSdtk(this.quoteDetails.quote_meta_id, delete_mta)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.modalService.dismissAll();
            this.sessionSt.store('showHideMTAReasons', true);  // Enable to clear mta reasons id if the page loads first time under quote edit screen            
           // this.router.navigateByUrl("/pre-qualifier/8/" + this.quoteDetails.id + '/' + type);
            this.router.navigateByUrl("/excess-protect/quote/" + this.quoteDetails.id + '/' + type);
          } else {
            this.modalService.open(content, { centered: true });
            this.mtaMsg = response.message;
            this.quoteType = type;
          }
        },
        (error) => {
          ;
        }
      );
    // } else {
    //   this.router.navigateByUrl("/quote-new/" + this.quoteData.id + '/' + type);
    // }
  }
  quoteTypes: any;
  //Get Quote Types
  getQuoteType(type) {
    // Get Quote Types
    this.quoteService.getQuoteTypes(1)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.quoteTypes = response.result.types;
            this.quoteTypes.filter(x => x.type == type);
          }
        },
        (error) => {
          ;
        }
      );
  }
  getClaims(quote_id) {
    this.quoteService.getQuoteClaims(quote_id)
      .subscribe(
        (response: any) => {
          let impClaims = response.result;
          if (impClaims.length > 0) {
            this.hasImportantClaims = true;
          }
        });
  }
}
